import dynamic from 'next/dynamic';

const FiltersCDynamicDefault = dynamic(
	() => import('rheostat/initialize').then(() => import('./default')),
	{
		ssr: false,
	},
);

export default FiltersCDynamicDefault;
